import React from 'react';
import Modal from '../shared/Modal';
import { safeRender } from '../../helpers/util';

class ClientAccountToggleModal extends React.Component {
  render() {
    const { client, isOpen, closeModal } = this.props;
    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <h2 className="h2 modal__heading">Deactivate Account</h2>
        <div className="form__row--spacer">
          <div className="modal__p">
            <p className="p">
              Are you sure you want to deactivate this account? This will remove
              all upcoming services for this client.
            </p>
          </div>
          <p className="p p--bold">Name</p>
          <p className="p">{safeRender('name', client)}</p>
        </div>
        <div className="form__row">
          <div className="form__row-item--half">
            <div
              className="btn btn--hollow-red-bright btn--full-width"
              onClick={closeModal}
            >
              Cancel
            </div>
          </div>
          <div className="form__row-item--half">
            <div
              className="btn btn--solid-red btn--full-width"
              onClick={this.props.toggleAccountStatus}
            >
              Deactivate
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default ClientAccountToggleModal;



// WEBPACK FOOTER //
// ./src/components/client/ClientAccountToggleModal.js